<template>
  <div class="dropbox">
    <input
      type="file"
      multiple
      :name="name"
      accept="*"
      class="inputFile"
      @change="filesChange($event.target)"
    >
    <p
      v-if="!files.length"
    >
      description
    </p>
    <div
      v-if="files.length"
      class="wrapper"
    >
      <div
        v-for="(file, index) in files"
        :key="`file_${index}`"
        class="item-wrapper"
      >
        <v-icon size="50">
          file_copy
        </v-icon>
        <span class="item-name">{{ file.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export const STATUS = {
  INITIAL: 0,
  SAVING: 1,
  SUCCESS: 2,
  FAILED: 3,
};

export default {
  name: 'MultiFileSelect',

  props: {
    name: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    onFileChange: {
      type: Function,
      default: () => ({}),
    },
  },

  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      files: [],
    };
  },

  computed: {
    isInitial() {
      return this.currentStatus === STATUS.INITIAL;
    },

    isSuccess() {
      return this.currentStatus === STATUS.SUCCESS;
    },

    isFailed() {
      return this.currentStatus === STATUS.FAILED;
    },
  },

  mounted() {
    this.reset();
  },

  methods: {
    reset() {
      this.currentStatus = STATUS.INITIAL;
      this.files = [];
    },

    filesChange(target) {
      const { files } = target;
      if (!files.length) {
        this.currentStatus = STATUS.INITIAL;

        return;
      }

      this.fileCount = files.length;
      this.files = Object.values(files);
      this.onFileChange(this.files);
    },
  },
};
</script>

<style>
.dropbox {
  outline: 2px dashed grey;
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px;
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0;
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

.wrapper {
  display: flex;
  flex-wrap: wrap;
}

.item-wrapper {
  width: 100px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.item-name {
  width: 100%;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/MultiFileSelect.vue